import { Close } from '@mui/icons-material';
import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';

import SimplePlayer from '@/components/simple-player/SimplePlayer';
import type { Item } from '@/models';
import itemUtils from '@/utils/itemUtils';

interface Iprops {
  asset: Item;
  handleClose: () => void;
}
const AssetPlayer = ({ asset, handleClose }: Iprops) => {
  const assetSrc = itemUtils.getVideoProxyUrl(asset);

  return (
    <Dialog open fullWidth maxWidth="sm" className="asset-preview-container">
      <DialogTitle className="header">
        {asset.data.businessMetadata.title}
        <IconButton aria-label="close" onClick={handleClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ minHeight: '40vh' }}>
        <SimplePlayer srcUrl={assetSrc} />
        <Typography>Duration: {asset?.duration}</Typography>
      </DialogContent>
    </Dialog>
  );
};

export default AssetPlayer;
